import { Box } from "@mui/material";
import backgroundImageSrc from "../../assets/background.jpg";
/**
 * AuthLayout - Full-page centered layout with background image
 * Common pattern for login, registration, password reset pages
 *
 * Features:
 * - Fullscreen background image with darkening filter
 * - Centered content area
 * - Responsive on mobile/tablet
 *
 * @param {object} props
 * @param {string} props.backgroundImage - URL to background image
 * @param {number} props.brightness - Background brightness filter 0-1 (default: 1)
 * @param {React.ReactNode} props.children - Page content (typically a Card)
 */
export default function AuthLayout({
  backgroundImage = backgroundImageSrc,
  brightness = 1,
  children,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: `brightness(${brightness})`,
          zIndex: 0,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(180deg, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.4) 100%)",
          pointerEvents: "none",
          zIndex: 1,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          boxSizing: "border-box",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
